export default {"src":"/_next/static/media/no_fees_slate.a83b72c4.svg","height":506,"width":506,"blurWidth":0,"blurHeight":0};